import { Phone, MessageCircle, Mail, Instagram, Linkedin } from "lucide-react";
import { TikTok } from "./TikTokIcon";

const digits = (s) => (s || "").replace(/[^\d+]/g, "");
const isEmail = (s) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test((s || "").trim());
const isPhone = (s) => digits(s).replace("+", "").length >= 6 && !/[a-z@]/i.test(s || "");

const igHandle = (s) => (s || "").trim().replace(/^https?:\/\/(www\.)?instagram\.com\//i, "").replace(/^@/, "").replace(/[/?#].*$/, "");
const ttHandle = (s) => (s || "").trim().replace(/^https?:\/\/(www\.)?tiktok\.com\//i, "").replace(/^@/, "").replace(/[/?#].*$/, "");
const liUrl = (s) => { const t = (s || "").trim(); return !t ? "" : /^https?:\/\//i.test(t) ? t : `https://www.linkedin.com/in/${t.replace(/^@/, "").replace(/^(www\.)?linkedin\.com\/in\//i, "").replace(/\/$/, "")}`; };

// Older contacts kept everything in a single "details" field
const resolved = (c) => ({
  phone: c.phone || (isPhone(c.details) ? c.details : ""),
  whatsapp: c.whatsapp,
  email: c.email || (isEmail(c.details) ? c.details.trim() : ""),
  instagram: c.instagram,
});

export const contactLinks = (c) => {
  const r = resolved(c);
  const wa = digits(r.whatsapp || r.phone).replace(/^\+/, "").replace(/^00/, "");
  return [
    r.phone && { kind: "call", href: `tel:${digits(r.phone)}`, label: `Call ${r.phone}`, icon: Phone, color: "#7DD3FC" },
    wa && { kind: "whatsapp", href: `https://wa.me/${wa}`, label: "WhatsApp", icon: MessageCircle, color: "#34D399" },
    r.email && { kind: "email", href: `mailto:${r.email}`, label: `Email ${r.email}`, icon: Mail, color: "#FBBF24" },
    r.instagram && igHandle(r.instagram) && { kind: "instagram", href: `https://instagram.com/${igHandle(r.instagram)}`, label: `@${igHandle(r.instagram)}`, icon: Instagram, color: "#F472B6" },
    c.linkedin && liUrl(c.linkedin) && { kind: "linkedin", href: liUrl(c.linkedin), label: "LinkedIn", icon: Linkedin, color: "#60A5FA" },
    c.tiktok && ttHandle(c.tiktok) && { kind: "tiktok", href: `https://www.tiktok.com/@${ttHandle(c.tiktok)}`, label: `TikTok @${ttHandle(c.tiktok)}`, icon: TikTok, color: "#E2E8F0" },
  ].filter(Boolean);
};

export const ContactLinks = ({ c, testId }) => {
  const links = contactLinks(c);
  if (!links.length) return null;
  return (
    <div className="flex flex-wrap gap-1.5 shrink-0" data-testid={testId}>
      {links.map(({ kind, href, label, icon: Icon, color }) => (
        <a key={kind} href={href} target={kind === "call" || kind === "email" ? undefined : "_blank"} rel="noreferrer" title={label} aria-label={label}
          className="w-8 h-8 rounded-full grid place-items-center border border-white/10 hover:bg-white/10 transition-colors" style={{ color }}
          data-testid={`${testId}-${kind}`}>
          <Icon size={14} />
        </a>
      ))}
    </div>
  );
};
